export class FileResponse {
  public fileId: string;
  public fileName: string;
  public fileSize: number;
  public fileContentType: string;
}
